import type { PageContextResourceRole, PageContextResourceType } from './types';

type ResourceIdentity = {
  type: PageContextResourceType;
};

const withRole = <T extends ResourceIdentity, R extends PageContextResourceRole>(
  resource: T,
  role: R,
): T & { role: R } => ({ ...resource, role });

/** Mark the main resource represented by the page. */
export const subjectResource = <T extends ResourceIdentity>(resource: T): T & { role: 'subject' } =>
  withRole(resource, 'subject');

/** Mark a child resource currently selected within the page. */
export const selectedResource = <T extends ResourceIdentity>(
  resource: T,
): T & { role: 'selected' } => withRole(resource, 'selected');

/** Mark a supporting resource that helps interpret the page. */
export const relatedResource = <T extends ResourceIdentity>(resource: T): T & { role: 'related' } =>
  withRole(resource, 'related');
